import { put } from "redux-saga/effects";
import { startLoading } from "../../common/slice";
import { call } from "redux-saga/effects";
import toast from "react-hot-toast";
import { applySagaError } from "../../utils/saga";
import { stopLoading } from "../../common/slice";
import { invokeApi } from "@/api/invoke.api";



export function* upgradeSubscriptionSaga() {
    try {
        yield put(startLoading());

        yield call(invokeApi.upgradeSubscription);
        toast.success("Successfully upgraded to Advanced Plan!");
        window.location.reload();
        
    } catch (error) {
        yield* applySagaError(error, {
            operationName: "auth.upgradeSubscription",
            endpoint: "upgrade-subscription",
            sentryContext: { function: "upgrade-subscription" },
        });
        toast.error("Failed to upgrade plan. Please try again or contact support.", {
            duration: 8000,
        });
    } finally {
        yield put(stopLoading());
    }
}